import { Link } from 'react-router-dom'
import { useAuth } from '@/api/auth'
import { PackagePlus, Truck, ClipboardList, MapPin, ScrollText, ShieldAlert, Users, ClipboardCheck, RefreshCw, Grid3x3, PackageSearch } from 'lucide-react'

const TILES = [
  { to: '/warehouse/einlagern', label: 'Einlagern', desc: 'Palette scannen → Platz scannen', icon: PackagePlus, need: 'book' as const },
  { to: '/warehouse/umfahren', label: 'Ware umfahren', desc: 'Verschieben · Auslagern · Auspacken', icon: Truck, need: 'book' as const },
  // RA-WI8 (Re-Audit Runde 1): Wareneingang- und Inventur-LISTEN sind Backend-seitig
  // 'general' (GET /receipt/, GET /inventur/ — routes.ts) — nur das Anlegen (lead) bzw.
  // Zaehlen (count) ist hoeher gegated. Welle W hatte das faelschlich auf 'book'/'count'
  // verengt und damit reine Leiter (kein book/count) ausgesperrt; Aktionen bleiben inline
  // gated (ReceiptsPage.tsx: warehouse.lead, InventurPage/-DetailPage: lead bzw. count).
  { to: '/warehouse/wareneingang', label: 'Wareneingang', desc: 'WE-Aufträge + Etiketten', icon: ClipboardList, need: 'general' as const },
  { to: '/warehouse/journal', label: 'Journal', desc: 'Alle Bewegungen', icon: ScrollText, need: 'general' as const },
  // Task 14: Fillup-GET-Endpoints sind Backend-seitig 'general' — Storno-Aktion darin
  // bleibt inline lead-gated (gleiches Muster wie Wareneingang/Inventur oben).
  // P3 (Welle 1b): Route bleibt /warehouse/nachschub, sichtbar heisst der Bereich
  // jetzt nach der Taetigkeit im Grosslager (Kommissionieren).
  { to: '/warehouse/nachschub', label: 'Kommissionieren', desc: 'Kommissionier-Listen · Vormerkungen · FIFO-Overrides', icon: RefreshCw, need: 'general' as const },
  { to: '/warehouse/leiter', label: 'Leiter-Listen', desc: 'Klärfälle · Warnungen · Unterlieferungen', icon: ShieldAlert, need: 'lead' as const },
  { to: '/warehouse/nullmengen', label: 'NULL-MENGEN', desc: 'Großlager leer · Packort nachzählen · Fristen', icon: PackageSearch, need: 'lead' as const },
  { to: '/warehouse/mitarbeiter', label: 'Mitarbeiter (Scan-App)', desc: 'PINs anlegen · Aktiv/Inventur verwalten', icon: Users, need: 'lead' as const },
  { to: '/warehouse/priostahl-classification', label: 'Artikel-Zuordnung', desc: 'Ungeklärte Firma · Original und Verknüpfung prüfen', icon: ShieldAlert, need: 'lead' as const },
  { to: '/warehouse/inventur', label: 'Inventur', desc: 'Sessions anlegen · zählen · Differenzen', icon: ClipboardCheck, need: 'general' as const },
  { to: '/warehouse/handregal', label: 'Handregal-Karte', desc: 'Zählstand je Fach · was noch fehlt', icon: Grid3x3, need: 'general' as const },
  // Plätze bewusst ganz unten: Stammdaten-Funktion, selten genutzt (User 2026-07-10)
  { to: '/warehouse/lager-navi/plaetze', label: 'Plätze', desc: 'Stammdaten + Regal-Etiketten', icon: MapPin, need: 'general' as const },
]

export default function WarehouseHome() {
  const { warehouse } = useAuth()
  const tiles = TILES.filter((t) => warehouse[t.need])
  return (
    <div className="p-4 max-w-3xl mx-auto">
      <h1 className="text-xl font-bold mb-4">Lager</h1>
      <p className="text-sm text-muted mb-4">{warehouse.lead ? 'Stahlia und Priostahl' : 'Stahlia'}</p>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        {tiles.map((t) => (
          <Link key={t.to} to={t.to}
            className="flex items-center gap-4 rounded-xl border border-line bg-panel p-5 active:scale-[0.99] hover:bg-primary-soft transition">
            <t.icon className="size-8 shrink-0 text-primary" />
            <div>
              <div className="font-semibold text-base">{t.label}</div>
              <div className="text-sm text-muted">{t.desc}</div>
            </div>
          </Link>
        ))}
      </div>
      {tiles.length === 0 && (
        <p className="text-muted">Keine Lager-Berechtigung. Bitte beim Admin melden.</p>
      )}
    </div>
  )
}
